const UPDATES = [
  {
    date: '2026.07.30',
    time: '14:32',
    title: '某女星工作室正式发布律师函回应劈腿传闻',
  },
  {
    date: '2026.07.30',
    time: '11:15',
    title: '热门综艺节目组就录制冲突事件发布官方声明',
  },
  {
    date: '2026.07.30',
    time: '09:08',
    title: '税务部门透露：已有多位艺人主动补缴税款',
  },
  {
    date: '2026.07.29',
    time: '22:40',
    title: '新晋流量小生后援会发文呼吁粉丝理性对待恋情传闻',
  },
  {
    date: '2026.07.29',
    time: '18:22',
    title: '横店影视城：年度古装巨制剧组今日正式进场搭建',
  },
  {
    date: '2026.07.29',
    time: '15:05',
    title: '知名网红团队就直播翻车事件向消费者致歉',
  },
  {
    date: '2026.07.29',
    time: '10:48',
    title: '音乐节主办方回应后台视频泄露：将追究法律责任',
  },
  {
    date: '2026.07.28',
    time: '20:30',
    title: '业内爆料：某S+项目主演阵容即将官宣',
  },
  {
    date: '2026.07.28',
    time: '16:12',
    title: '大牌导演新片选角进入最后阶段，三位顶流角逐',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">最新快讯</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            实时追踪娱乐圈最新动态，第一时间为你送上明星大瓜快讯
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10">
            <div className="absolute left-3 md:left-4 top-2 bottom-2 w-px bg-background-300"></div>

            <div className="space-y-6">
              {UPDATES.map((item, i) => (
                <div key={i} className="relative">
                  <div className="absolute -left-[23px] md:-left-[27px] top-1.5 w-2.5 h-2.5 rounded-full bg-primary-500 ring-4 ring-background-100"></div>
                  <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 mb-1">
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                    <span className="hidden sm:block text-xs text-foreground-400">·</span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-900 font-medium leading-relaxed">
                    {item.title}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}